import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const LegalDisclaimers = () => {
  return (
    <div>
      <Navbar />
      <div style={{ minHeight: '100vh', backgroundColor: '#fff', paddingTop: '120px', paddingBottom: '60px' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>
          <Link to="/" style={{ display: 'inline-block', marginBottom: '20px', color: '#dc2626', textDecoration: 'none', fontSize: '14px' }}>
            ← Back to Home
          </Link>
          
          <div style={{ backgroundColor: '#000', color: '#fff', padding: '30px', marginBottom: '30px', borderRadius: '8px' }}>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '10px' }}>Legal Disclaimers & Intellectual Property Rights Policy</h1>
            <p style={{ opacity: 0.9 }}>Operated by MAXRAD SOFTWARE INDIA PVT LTD (Brand name ARTCARDO under the division DULCIA.ART)</p>
            <p style={{ opacity: 0.7, marginTop: '5px' }}>1542, 17th B, Main, 5th Block, HBR Layout, Bangalore - 560043, Karnataka, India</p>
          </div>

          <div style={{ backgroundColor: '#f9fafb', padding: '30px', borderRadius: '8px', lineHeight: '1.8' }}>
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>1. Introduction</h2>
              <p style={{ color: '#374151' }}>
                This Policy outlines the ownership, protection, and permitted use of creative works and content on ARTCARDO.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>2. Ownership and Copyright</h2>
              <p style={{ color: '#374151' }}>
                All artworks remain the exclusive intellectual property of the respective Seller. Copyright does not transfer to buyers unless explicitly agreed.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>3. Seller's Declaration</h2>
              <p style={{ color: '#374151' }}>
                Sellers declare that their works are original and do not infringe third-party IP rights.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>4. Buyer Rights</h2>
              <p style={{ color: '#374151' }}>
                Buyers acquire ownership of the physical item only, not reproduction or commercial rights.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>5. Contact Information</h2>
              <p style={{ color: '#374151' }}><strong>MAXRAD SOFTWARE INDIA PVT LTD</strong></p>
              <p style={{ color: '#374151' }}>(Brand name ARTCARDO under the division DULCIA.ART)</p>
              <p style={{ color: '#374151' }}>Email: <a href="mailto:dulciaart@gmail.com" style={{ color: '#dc2626', textDecoration: 'underline' }}>dulciaart@gmail.com</a></p>
              <p style={{ color: '#374151' }}>Phone: <a href="tel:+919019028615" style={{ color: '#dc2626', textDecoration: 'underline' }}>+91 90190 28615</a></p>
              <p style={{ color: '#374151' }}>Address: 1542, 17th B, Main, 5th Block, HBR Layout, Bangalore - 560043, Karnataka, India</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LegalDisclaimers;
